module.exports = __webpack_public_path__ + "img/jishu-1.584ad2e4.jpg";